/**
 * Normalizes a media type value for case- and whitespace-insensitive lookup.
 *
 * Extracted into its own dependency-free module (no imports) so it can be
 * shared by both `adapters/registry.ts` (adapter lookup) and `validate-row.ts`
 * (enum validation) without creating a circular import — `registry.ts` pulls
 * in adapter modules that import `validate-row.ts`.
 */
export function normalizeMediaType(mediaType: string): string {
  return mediaType.trim().toLowerCase();
}
